// extracted by mini-css-extract-plugin
module.exports = {"FeedbackContainer":"Feedback_FeedbackContainer__cwWtc","FeedbackLink":"Feedback_FeedbackLink__rMBUt"};